// extracted by mini-css-extract-plugin
export default {"journeyStages":"-ds9N","journeyStagesItem":"QdnVw","journeyIcon":"pScMj","journeyText":"-uoAa","skeleton-progress":"sP38a"};